import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import "./index.css"; // <-- måste in först för Tailwind/global CSS
import "./i18n";
import { ToastProvider } from "./components/ToastProvider";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CookieConsentProvider } from "./context/CookieConsentContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <BrowserRouter>
      <I18nextProvider i18n={i18n}>
        <CookieConsentProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </CookieConsentProvider>
      </I18nextProvider>
    </BrowserRouter>
  </HelmetProvider>
);
